import React from "react";
import { CheckCircle2, XCircle, CheckSquare, Square } from "lucide-react";

const BulkActionBar = ({
  selectedCount = 0,
  totalCount = 0,
  selectAllChecked = false,
  onSelectAllToggle,
  onBulkApprove,
  onBulkReject,
  processing = false,
}) => {
  if (totalCount === 0) return null;

  return (
    <div className="bg-white text-slate-900 rounded-xl p-3 mb-4 flex flex-wrap items-center justify-between gap-3 shadow-sm border border-slate-200">
      <div className="flex items-center gap-3">
        <button
          onClick={onSelectAllToggle}
          className="flex items-center gap-2 text-xs font-bold text-slate-800 hover:text-slate-900 transition-colors"
        >
          {selectAllChecked ? (
            <CheckSquare className="w-4 h-4 text-blue-600" />
          ) : (
            <Square className="w-4 h-4 text-slate-400" />
          )}
          <span>{selectAllChecked ? "Deselect All" : "Select All"}</span>
        </button>

        <span className="text-xs text-slate-500 border-l border-slate-200 pl-3">
          <strong className="text-slate-900 font-bold">{selectedCount}</strong> of {totalCount} selected
        </span>
      </div>

      {selectedCount > 0 && (
        <div className="flex items-center gap-2">
          <button
            onClick={onBulkApprove}
            disabled={processing}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs shadow transition-all disabled:opacity-50"
          >
            <CheckCircle2 className="w-4 h-4" />
            <span>Approve Selected ({selectedCount})</span>
          </button>

          <button
            onClick={onBulkReject}
            disabled={processing}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-rose-600 hover:bg-rose-500 text-white font-bold text-xs shadow transition-all disabled:opacity-50"
          >
            <XCircle className="w-4 h-4" />
            <span>Reject Selected ({selectedCount})</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default BulkActionBar;
